// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: '523ce879-1039-4e06-9377-35d1ee004681',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '4aeffdd8-5f72-4259-86bd-3c59741f0bc7',
      type: 'Container',
      name: 'wrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '523ce879-1039-4e06-9377-35d1ee004681'
    },
    {
      id: '6cae0158-ad89-4a1f-b94b-6c484e1f1d1d',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 52,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 0.215517
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '523ce879-1039-4e06-9377-35d1ee004681',
      stateByName: {
        premium: {
          alpha: 0
        },
        premiumOpened: {
          alpha: 0
        }
      }
    },
    {
      id: '004a4266-e352-4681-95b3-df2884770feb',
      type: 'Sprite',
      name: 'chest',
      className: '',
      x: 0,
      y: 57,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Chest_Gold',
      parent: '523ce879-1039-4e06-9377-35d1ee004681',
      stateByName: {
        premium: {
          scale: {
            x: 0.7
          }
        },
        premiumOpened: {
          scale: {
            x: 0.7
          },
          texture: 'Chest_Gold_Open_Empty'
        },
        chestBronze: {
          texture: 'Chest_Bronze'
        },
        chestBronzeOpened: {
          texture: 'Chest_Bronze_Open_Empty'
        },
        chestSilver: {
          texture: 'Chest_Silver'
        },
        chestSilverOpened: {
          texture: 'Chest_Silver_Open_Empty'
        }
      }
    },
    {
      id: '6d423a9e-76d8-4acf-8861-09aaac696bb8',
      type: 'Sprite',
      name: 'pointer',
      className: '',
      x: 98,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Item_Blue_Background_Pointer',
      parent: '4aeffdd8-5f72-4259-86bd-3c59741f0bc7',
      stateByName: {
        premium: {
          texture: 'Item_Gold_Background_Pointer',
          x: -123
        },
        premiumOpened: {
          texture: 'Item_Gold_Background_Pointer',
          x: -123
        }
      }
    },
    {
      id: 'bd25243e-4577-4419-b2ce-7ad082d8fe9f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Item_Blue_Background_Variation',
      parent: '4aeffdd8-5f72-4259-86bd-3c59741f0bc7',
      stateByName: {
        premium: {
          texture: 'Item_Gold_Background_Variation',
          y: 2
        },
        premiumOpened: {
          texture: 'Item_Gold_Background_Variation',
          y: 2
        }
      }
    },
    {
      id: 'd1a2ccdc-8532-4a29-b673-fc5cc2a7f51b',
      type: 'Container',
      name: 'backgroundBlur',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4aeffdd8-5f72-4259-86bd-3c59741f0bc7',
      stateByName: {
        chestSilver: {
          alpha: 0.5
        },
        chestBronze: {
          alpha: 0.3
        }
      }
    },
    {
      id: 'b85f799c-0b92-4c83-aa19-a4aea869f621',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 0.5,
      visible: false,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '4aeffdd8-5f72-4259-86bd-3c59741f0bc7',
      stateByName: {
        premium: {
          visible: true
        },
        premiumOpened: {
          visible: true
        }
      }
    },
    {
      id: '35cbe4c6-9f6a-4996-ae8e-48cad238e7b0',
      type: 'Sprite',
      name: '',
      className: '',
      x: -31,
      y: -19,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.793103,
        y: 0.49569
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'd1a2ccdc-8532-4a29-b673-fc5cc2a7f51b'
    },
    {
      id: '9b7eaa40-fced-494b-abda-73808ea399c4',
      type: 'Sprite',
      name: '',
      className: '',
      x: 35,
      y: 27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.793103,
        y: 0.49569
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'd1a2ccdc-8532-4a29-b673-fc5cc2a7f51b'
    },
    {
      id: '626e6c6b-de0c-4f0b-ad19-b7c3292d5a9f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -49,
      y: 15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.530172,
        y: 0.49569
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'd1a2ccdc-8532-4a29-b673-fc5cc2a7f51b'
    },
    {
      id: '9bc64613-16a5-4b0c-a7fe-aefd494b696f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 36,
      y: -32,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.793103,
        y: 0.49569
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'd1a2ccdc-8532-4a29-b673-fc5cc2a7f51b'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'premium',
    'premiumOpened',
    'chestBronze',
    'chestBronzeOpened',
    'chestSilver',
    'chestSilverOpened'
  ],
  handleResize: false
} as const;

export class SeasonPassChestRewardLayout {
  static raw = raw;
  root!: Container;
  wrapper!: Container;
  chest!: Sprite;
  pointer!: Sprite;
  backgroundBlur!: Container;
  rays!: Sprite;
  rotate_SPL!: (Sprite)[];
  StateName!: 'premium' | 'premiumOpened' | 'chestBronze' | 'chestBronzeOpened' | 'chestSilver' | 'chestSilverOpened';

  constructor() {
    populate(this, raw);
  }
}
